// change this value when you use Policy Panel in ExtJs (true) or Storybook (false)
export const USE_EXT_JS_VERSION = false;
